import {environment} from '../../lib/environment';
import {HttpPromiseState} from '../../lib/helpers';
import {SuccessResponse} from '../models/response-model';
import {TimeZone, TimeZoneUpdateModel} from '../models/timezone';
import {httpClient} from '../utils/httpClient';

class TimeZoneLoaders {
  list(): HttpPromiseState<readonly TimeZone[]> {
    let url = `${environment.apiServer}/timezone/list`;
    return httpClient.state.get<readonly TimeZone[]>(url);
  }

  create(request: TimeZoneUpdateModel)
    : HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/timezone/create`;
    return httpClient.state.post<SuccessResponse>(url, request);
  }

  update(userId: number, request: TimeZoneUpdateModel)
    : HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/timezone/${userId}`;
    return httpClient.state.put<SuccessResponse>(url, request);
  }

  delete(userId: number)
    : HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/timezone/${userId}`;
    return httpClient.state.delete<SuccessResponse>(url);
  }
}

export const timeZoneLoaders = new TimeZoneLoaders();
